/**
 * <ColumnResizeHandle> — the draggable right edge of a header cell. 13-ui-screens.md §7.5 / §7.7
 * [N] (client request, 13 Oct 2026). The drag itself, the freeze and the storage are
 * `lib/column-widths.ts`'s `useResizableColumns`; this is only the target.
 *
 * Its header cell must be `position: relative`. It is mouse-only on purpose — no `tabIndex` —
 * because the day sheet is a keyboard grid (§7.10) and seven extra tab stops in the header would
 * sit between the header band and the first job line for every clerk who never resizes anything.
 */
import type { PointerEvent as ReactPointerEvent } from 'react';
import './column-resize.css';

export interface ColumnResizeHandleProps {
  /** The column's name, for the accessible label: `Resize Work type column`. */
  label: string;
  onPointerDown: (event: ReactPointerEvent<HTMLElement>) => void;
  /** Back to the shipped layout. */
  onReset: () => void;
}

export function ColumnResizeHandle({ label, onPointerDown, onReset }: ColumnResizeHandleProps) {
  return (
    <span
      role="separator"
      aria-orientation="vertical"
      aria-label={`Resize ${label} column`}
      title="Drag to resize. Double-click to fit the columns to the window again."
      className="cm-col-resize"
      onPointerDown={onPointerDown}
      onDoubleClick={(e) => {
        e.stopPropagation();
        onReset();
      }}
      onClick={(e) => e.stopPropagation()}
    />
  );
}
